import React from 'react';
import { Link } from 'react-router-dom';
import { Flag } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#262626] mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded bg-[#FF3B30] flex items-center justify-center">
                <Flag className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-heading font-bold text-xl text-white">CROWN VIC NATION</h3>
                <p className="text-xs uppercase tracking-[0.2em] text-gray-500">Short Track Racing</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm max-w-md">
              Your home for Crown Victoria short track racing news, community discussions, and race cars for sale across the United States.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-[0.2em] text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/news" className="text-gray-400 hover:text-[#FF3B30] text-sm transition-colors">
                  Latest News
                </Link>
              </li>
              <li>
                <Link to="/forum" className="text-gray-400 hover:text-[#FF3B30] text-sm transition-colors">
                  Forum
                </Link>
              </li>
              <li>
                <Link to="/marketplace" className="text-gray-400 hover:text-[#FF3B30] text-sm transition-colors">
                  Cars For Sale
                </Link>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-[0.2em] text-white mb-4">Community</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/forum?category=general" className="text-gray-400 hover:text-[#FF3B30] text-sm transition-colors">
                  General Discussion
                </Link>
              </li>
              <li>
                <Link to="/forum?category=tech" className="text-gray-400 hover:text-[#FF3B30] text-sm transition-colors">
                  Technical Help
                </Link>
              </li>
              <li>
                <Link to="/forum?category=builds" className="text-gray-400 hover:text-[#FF3B30] text-sm transition-colors">
                  Build Threads
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#262626] mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Crown Vic Nation. Built for the Crown Vic racing community.
          </p>
        </div>
      </div>
    </footer>
  );
}
